<template>
    <div>
        <a class="text-bold title-link" :href="'#' + link">{{ name }}</a>
    </div>
</template>
<script>
import Vue from 'vue';

export default {
    data() {
        return {

        }
    },

    components: {

    },

    props: ['initialValue', 'css', 'data'],

    computed: {
        link() {
            return this.helpers('uriFormat')(_.get(this.data, 'link', ''));
        },
        name() {
            return [_.get(this.data, 'firstname', ''), _.get(this.data, 'lastname', '')]
                .filter(piece => !!piece)
                .join(' ');
        }
    },

    mounted() {

    },

    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/FullnameTitleComponent.vue